// utils
import * as yup from 'yup';
import { t } from 'i18next';

const requiredArray = (fieldKey: string) =>
  yup
    .array()
    .min(1, t('validationFieldRequired', { name: t(fieldKey) }))
    .of(
      yup.object({
        id: yup.string().required()
      })
    )
    .required();

export const newFlexRequestSchema = yup.object().shape({
  reason: yup
    .object()
    .required(
      t('validationFieldRequired', {
        name: t('flexHistory.requestReason')
      })
    )
    .nullable()
    .default(null),
  date: yup
    .date()
    .required(t('validationFieldRequired', { name: t('date') }))
    .nullable()
    .default(null),
  costCenter: yup
    .object()
    .required(t('validationFieldRequired', { name: t('planUnit') }))
    .nullable()
    .default(null),
  rosterFunction: yup
    .object()
    .required(
      t('validationFieldRequired', { name: t('flexHistory.requestFunction') })
    )
    .nullable()
    .default(null),
  dutyTypeId: yup
    .string()
    .required(t('validationFieldRequired', { name: t('dutyHourType') }))
    .nullable()
    .default(null),
  qualifications: requiredArray('qualifications'),
  preferences: requiredArray('preferences')
});
